import React, { useEffect } from 'react';

import { Container, Typography, styled } from '@mui/material';

import { setSeoMeta } from './seo';

const Paragraph = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  '&:last-of-type': {
    marginBottom: 0,
  },
}));

const SITE = 'ru.lett.cc';

export default function PrivacyWeb() {
  useEffect(() => {
    setSeoMeta({
      title: 'Политика обработки персональных данных',
      description:
        'Порядок обработки и защиты персональных данных пользователей сайта ru.lett.cc. Оператор: Мошков С.А., ИНН 525903882831.',
    });
  }, []);

  return (
    <Container maxWidth="md" sx={{ padding: 3 }}>
      <Paragraph>
        Настоящая Политика обработки персональных данных (далее — «Политика») определяет порядок
        обработки и защиты персональных данных пользователей сайта {SITE}.
      </Paragraph>

      <Paragraph variant="subtitle1" component="p" sx={{ fontWeight: 700 }}>
        1. Общие положения
      </Paragraph>
      <Paragraph>
        1.1. Оператором персональных данных является самозанятый гражданин Российской Федерации Мошков
        Сергей Александрович, ИНН 525903882831 (далее — «Оператор»).
      </Paragraph>
      <Paragraph>
        1.2. Политика разработана в соответствии с Федеральным законом РФ №152-ФЗ «О персональных
        данных».
      </Paragraph>
      <Paragraph>1.3. Использование сайта означает согласие Пользователя с настоящей Политикой.</Paragraph>
      <Paragraph>
        1.4. В случае несогласия с условиями Политики Пользователь обязан прекратить использование
        сайта.
      </Paragraph>

      <Paragraph variant="subtitle1" component="p" sx={{ fontWeight: 700 }}>
        2. Персональные данные, которые обрабатываются
      </Paragraph>
      <Paragraph>2.1. Оператор может обрабатывать следующие персональные данные:</Paragraph>
      <Paragraph component="div">
        <ul>
          <li>адрес электронной почты;</li>
          <li>уникальный идентификатор пользователя, предоставляемый сервисами Google или Apple;</li>
          <li>технические данные (IP-адрес, данные устройства, cookies, данные браузера).</li>
        </ul>
      </Paragraph>
      <Paragraph>
        2.2. Персональные данные предоставляются Пользователем самостоятельно при использовании
        сторонних сервисов авторизации (Google, Apple).
      </Paragraph>
      <Paragraph>2.3. Оператор не проверяет достоверность персональных данных.</Paragraph>

      <Paragraph variant="subtitle1" component="p" sx={{ fontWeight: 700 }}>
        3. Цели обработки персональных данных
      </Paragraph>
      <Paragraph>3.1. Персональные данные обрабатываются в следующих целях:</Paragraph>
      <Paragraph component="div">
        <ul>
          <li>регистрация и авторизация пользователя;</li>
          <li>предоставление доступа к сервису;</li>
          <li>исполнение договорных обязательств (в том числе по публичной оферте);</li>
          <li>обеспечение работоспособности сайта;</li>
          <li>улучшение качества сервиса.</li>
        </ul>
      </Paragraph>

      <Paragraph variant="subtitle1" component="p" sx={{ fontWeight: 700 }}>
        4. Правовые основания обработки
      </Paragraph>
      <Paragraph>4.1. Обработка осуществляется на основании:</Paragraph>
      <Paragraph component="div">
        <ul>
          <li>согласия Пользователя;</li>
          <li>необходимости исполнения договора;</li>
          <li>законных интересов Оператора.</li>
        </ul>
      </Paragraph>

      <Paragraph variant="subtitle1" component="p" sx={{ fontWeight: 700 }}>
        5. Условия обработки и хранения персональных данных
      </Paragraph>
      <Paragraph>
        5.1. Обработка персональных данных осуществляется с использованием автоматизированных средств.
      </Paragraph>
      <Paragraph>
        5.2. Персональные данные могут храниться и обрабатываться на серверах, расположенных за
        пределами Российской Федерации.
      </Paragraph>
      <Paragraph>
        5.3. Пользователь, принимая настоящую Политику, дает согласие на трансграничную передачу
        персональных данных.
      </Paragraph>
      <Paragraph>
        5.4. Оператор не гарантирует уровень защиты данных в иностранных юрисдикциях.
      </Paragraph>
      <Paragraph>
        5.5. Оператор принимает разумные меры для защиты данных, однако не гарантирует абсолютную
        безопасность.
      </Paragraph>

      <Paragraph variant="subtitle1" component="p" sx={{ fontWeight: 700 }}>
        6. Передача персональных данных третьим лицам
      </Paragraph>
      <Paragraph>6.1. Персональные данные могут передаваться следующим категориям третьих лиц:</Paragraph>
      <Paragraph component="div">
        <ul>
          <li>сервисам авторизации (Google, Apple);</li>
          <li>платежным системам;</li>
          <li>хостинг-провайдерам и иным техническим подрядчикам.</li>
        </ul>
      </Paragraph>
      <Paragraph>6.2. Оператор не контролирует и не несет ответственности за действия третьих лиц.</Paragraph>
      <Paragraph>
        6.3. Пользователь соглашается, что передача данных таким лицам осуществляется на его риск.
      </Paragraph>

      <Paragraph variant="subtitle1" component="p" sx={{ fontWeight: 700 }}>
        7. Cookies и технические данные
      </Paragraph>
      <Paragraph>7.1. Сайт может использовать cookies и аналогичные технологии.</Paragraph>
      <Paragraph>7.2. Cookies используются для:</Paragraph>
      <Paragraph component="div">
        <ul>
          <li>обеспечения работы сайта;</li>
          <li>аналитики и улучшения сервиса.</li>
        </ul>
      </Paragraph>
      <Paragraph>7.3. Пользователь может отключить cookies в настройках браузера.</Paragraph>

      <Paragraph variant="subtitle1" component="p" sx={{ fontWeight: 700 }}>
        8. Права пользователя
      </Paragraph>
      <Paragraph>8.1. Пользователь имеет право:</Paragraph>
      <Paragraph component="div">
        <ul>
          <li>получать информацию о своих данных;</li>
          <li>требовать их уточнения или удаления;</li>
          <li>отозвать согласие на обработку.</li>
        </ul>
      </Paragraph>
      <Paragraph>
        8.2. Реализация прав может быть ограничена техническими возможностями сервиса.
      </Paragraph>

      <Paragraph variant="subtitle1" component="p" sx={{ fontWeight: 700 }}>
        9. Ограничение ответственности
      </Paragraph>
      <Paragraph>9.1. Сайт и все связанные сервисы предоставляются «как есть» (as is).</Paragraph>
      <Paragraph>9.2. Оператор не гарантирует:</Paragraph>
      <Paragraph component="div">
        <ul>
          <li>бесперебойную работу сайта;</li>
          <li>отсутствие ошибок;</li>
          <li>сохранность данных;</li>
          <li>соответствие ожиданиям Пользователя.</li>
        </ul>
      </Paragraph>
      <Paragraph>9.3. Оператор не несет ответственности за:</Paragraph>
      <Paragraph component="div">
        <ul>
          <li>утрату данных;</li>
          <li>несанкционированный доступ третьих лиц;</li>
          <li>действия или бездействие третьих лиц;</li>
          <li>технические сбои, включая сбои интернета и инфраструктуры;</li>
          <li>последствия использования или невозможности использования сайта.</li>
        </ul>
      </Paragraph>
      <Paragraph>9.4. Пользователь использует сайт на свой риск.</Paragraph>

      <Paragraph variant="subtitle1" component="p" sx={{ fontWeight: 700 }}>
        10. Заключительные положения
      </Paragraph>
      <Paragraph>10.1. Оператор вправе изменять настоящую Политику без уведомления.</Paragraph>
      <Paragraph>10.2. Новая редакция вступает в силу с момента публикации.</Paragraph>
      <Paragraph>10.3. К настоящей Политике применяется законодательство Российской Федерации.</Paragraph>

      <Paragraph variant="subtitle1" component="p" sx={{ fontWeight: 700 }}>
        11. Контакты
      </Paragraph>
      <Paragraph>
        Самозанятый: Мошков Сергей Александрович
        <br />
        Город: Нижний Новгород
        <br />
        ИНН: 525903882831
        <br />
        Email: lett.posts@gmail.com
      </Paragraph>
    </Container>
  );
}
